<template>
  <div class="directory-container">
    <div class="directory-content">
      <div class="directory-breadcrumbs">
        <ExBreadcrumbs :breadcrumbsList="breadcrumbItems" />
      </div>

      <hr class="directory-divider" />

      <div class="directory-list">
        <div
          v-for="directory in directoryArray"
          :key="directory.id"
          class="directory-item"
        >
          <div class="directory-title">
            <span class="directory-text">{{ directory.title }}</span>
          </div>
          <div>
            <SwitchButton
              @onChange="handleChangeEvent"
              :label="directory.title"
              v-model="directory.value"
              :showTitle="false"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, getCurrentInstance } from "vue";
import ExBreadcrumbs from "@components/breadcrumbs/ExBreadcrumbs.vue";
import SwitchButton from "@components/SwitchButton/SwitchButton.vue";
import { updateDirectory } from "@/api";

const instance = getCurrentInstance();
const props = defineProps({
  dataSource: {
    type: Array,
    default: () => [],
  },
});

const breadcrumbItems = ref([
  { text: "Configuration", disabled: false, href: "/settings/configuration" },
  { text: "Directories", disabled: true },
]);

const directoryArray = ref([
  {
    id: 1,
    title: "Show Employee Directory",
    value: props?.dataSource?.show_employee_directory,
  },
  {
    id: 2,
    title: "Show Responsibilities Directory",
    value: props?.dataSource?.show_responsibilities_directories,
  },
]);
const handleChangeEvent = async (item) => {
  try {
    const accountId = localStorage.getItem("currentAccountID");
    const payload = {
      name: props?.dataSource?.name,
    };
    if (item.label === "Show Responsibilities Directory") {
      payload.show_responsibilities_directories = item.value;
    }
    if (item.label === "Show Employee Directory") {
      payload.show_employee_directory = item.value;
    }
   const response = await updateDirectory(accountId, payload);
   if (response) {
    localStorage.setItem("currentAccountDetails", JSON.stringify(response?.data));
    // Emit event to update App.vue sidebar in real-time
    if (instance?.proxy?.$root) {
      instance.proxy.$root.$emit("currentAccountDetailsUpdated", response?.data);
    }
   }
  } catch (error) {}
};
</script>

<style scoped>
.directory-container {
  display: flex;
  width: 100%;
  border: 1px solid #d0d5dd;
  border-radius: 12px;
  padding: 16px 18px;
}

.directory-content {
  width: 100%;
}

.directory-breadcrumbs {
  padding: 15px 8px;
}

.directory-divider {
  border: 1px solid #f2f4f7;
  margin: 16px 0;
  width: 100%;
}

.directory-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.directory-item {
  display: flex;
  align-items: center;
  gap: 64px;
}

.directory-title {
  min-width: 280px;
}

.directory-text {
  font-size: 14px;
  font-weight: 600;
  color: #344054;
  line-height: 20px;
}
</style>
